import React from 'react';
import ReactDOM from 'react-dom';
import TinyMCEvalueSelector from '../components/elementSelector/selectors/TinyMCEvalueSelector';
import store from '../store/store';
import { Provider } from 'react-redux';

/**
 * @description A TinyMCE plugin that is bound to a custom buttons
 * click handler. The button is for inserting value references into
 * the editor via a valuepicker displayed in a modal.
 */
const plugin = function plugin(editor) {

    editor.addButton('manywho_elements', {
        text: 'Insert Value',
        icon: false,
        onclick: () => {
            const modalContainer = document.getElementById('generic-modal');
            ReactDOM.render(
                <Provider store={store}>
                    <TinyMCEvalueSelector editor={editor} />
                </Provider>,
                modalContainer,
            );
        },
    });
};

export default plugin;
